import { ref, watch, computed, onMounted, reactive } from 'vue'
import Fuse from 'fuse.js';

export default function usePaginateTable(context) {

  /*
  * ref => em arrays, strings, numeros (retorna variavel com value e effect)
  * reactive => objetos (nao retorna variavel com value)
  */

  const billItems = ref([{}])
  const pagination = reactive({
    perPage: 5,
    currentPage: 1,
    perPageOptions: [5, 10, 25, 50, 'Todas'],
    total: 0
  })
  const searchQuery = ref('')
  const searchedData = ref([])
  const fuseSearch = ref([])

  const queriedData = computed(() => {
    let result = ref(billItems.value);

    if (searchedData.value.length > 0) { result.value = searchedData.value; }
    else {
      if (searchQuery.value) { result.value = [] }
    }

    return result.value.slice(from.value, to.value);
  })

  const to = computed(() => {
    if(pagination.perPage == 'Todas'){
      pagination.perPage = total.value
    }
    let highBound = from.value + pagination.perPage;

    if (total.value < highBound) {
      highBound = total.value
    }

    return highBound;
  })

  const from = computed(() => {

    if(pagination.perPage == 'Todas'){
      return 0
    }

    return pagination.perPage * (pagination.currentPage - 1);
  })

  const total = computed(() => {
    return searchedData.value.length > 0 ? searchedData.value.length : billItems.value.length;
  })

  const emitResetPagination = () => {
    context.emit("reset-pagination", 1)
  }

  function setPagination(value) { pagination = value }
  function getPagination() { return pagination }

  function setBillsItems(value) { billItems.value = ref(value) }
  function getBillsItems() { return billItems.value }

  function setSearchQuery(value) { searchQuery.value = value }
  function getSearchQuery() { return searchQuery.value }

  function setSearchedData(value) { searchedData.value = value }
  function getSearchedData() { return searchedData.value }

  function setFuseSearch(value) { fuseSearch.value = value }
  function getFuseSearch() { return fuseSearch.value }

  function formatDataLocaleString(oldData) {
    let d = new Date(oldData);
    let n = d.toLocaleString();
    return n;
  }

  function createFuseSearch(keys) {
    fuseSearch.value = new Fuse(billItems.value, {
      keys: keys,
      threshold: 0.3
    });
  }

  function sortChange({ prop, order }) {
    if (prop === undefined && order === undefined) {
      billItems.value.sort((a, b) => {
        return false
      })
    }

    if (prop) {
      billItems.value.sort((a, b) => {
        let aVal = a[prop]
        let bVal = b[prop]
        if (order === 'ascending') {
          return aVal > bVal ? 1 : -1
        }
        return aVal < bVal ? 1 : -1
      })
    } else {
      billItems.value.sort((a, b) => {
        return a > b ? 1 : -1
      })
    }
  }

  /* onMounted é um hook, funciona de mesmo modo que em um componente
  * Vue normal
  */
  onMounted(() => {
  });

  /*
  * O watch do Composable é por variável
  * Pode adicionar o oldValue também para verificar
  */
  watch(searchQuery, (newValue) => {
    let result = billItems.value;
    if (newValue !== '') {
      result = fuseSearch.value.search(newValue);
    }
    searchedData.value = result
    pagination.currentPage = 1
    emitResetPagination()
  })

  return {
    // Computed Data
    total,
    from,
    to,
    queriedData,
    searchQuery,

    // Methods - Getters, Setters
    setBillsItems,
    getBillsItems,
    setPagination,
    getPagination,
    setSearchQuery,
    getSearchQuery,
    setSearchedData,
    getSearchedData,
    setFuseSearch,
    getFuseSearch,

    // General Methods
    formatDataLocaleString,
    sortChange,
    createFuseSearch,
    emitResetPagination,
  }
}
